import OldestInvoice from './Oldest';
import { Redirect, withRouter } from 'react-router-dom';
import { IInitialState } from 'src/store/initialState';
import { connect } from 'react-redux';
import {
  datesFilterSel,
  statusFilterSel,
  invoicesActions,
  sortFilterSel,
  dataSel
} from 'src/store/modules/invoices';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';
import actions from 'src/store/modules/invoices/actions';
import {
  pageNumberSel,
  pageSizeSel,
  totalElementsSel,
  totalPagesSel,
  getInvoicesIsPendingSel
} from 'src/store/modules/invoices';
const mapStateToProps = (state: IInitialState) => ({
  datesFilter: datesFilterSel(state),
  statusFilter: statusFilterSel(state),
  sortFilter: sortFilterSel(state),
  isPending: getInvoicesIsPendingSel(state),
  pagination: {
    pageNumber: pageNumberSel(state),
    pageSize: pageSizeSel(state),
    totalElements: totalElementsSel(state),
    totalPages: totalPagesSel(state),
    getInvoicesIsPending: getInvoicesIsPendingSel(state)
  }
});
const mapDispatchToProps = (dispatch: any) => ({
  getInvoices: (filters: IFiltersInvoice, pagination: IPaginationInvoice) =>
    dispatch(actions.getInvoices(filters, pagination))
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(OldestInvoice));

interface IOldestInvoiceProps {
  getInvoices(): void;
}
